var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.34766 1.75049L1.84766 5.25049V13.7505C1.84766 14.3027 2.29541 14.7505 2.84766 14.7505H6.34766V9.25149L10.3477 9.25199V14.7505H14.8477V5.25049L8.34766 1.75049ZM13.8477 13.7505H11.3477V8.25199H10.3477L6.34766 8.25149H5.34766V9.25149V13.7505H2.84766V5.84774L8.34766 2.88624L13.8477 5.84774V13.7505Z","fill":"#16B639"}));
}

Home.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Home;

Home.default = Home;
